import React from 'react';
import './usersStats.css';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { keyNumberAction, searchAction } from "../../redux/rootReducer";

const UsersStats = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const usersStats = useSelector(state => state.usersStats);

    return (
        <div className="page__content">
            <div className="table__header">
                <div className="table__caption">Общие показатели</div>
            </div>
            <div className="stats__find-key button button--yellow" onClick={ () => {
                dispatch(keyNumberAction({
                    open: true,
                    number: '',
                    workout_id: '',
                    type: 'find'
                }));
            } }>Найти ключ</div>
            <div className="stats">
                <div className="stats__item">
                    <div className="stats__caption">Количество посетителей</div>
                    <div className="stats__content">
                        <i className="stats__ico stats__ico--users" />
                        <div className="stats__value">{ usersStats.users_count }</div>
                        <div className="stats__sub">
                            <div className="stats__sub-wrap stats__sub-wrap--male">
                                <div className="stats__sub-caption">Муж.:</div>
                                <div className="stats__sub-value">{ usersStats.male }</div>
                            </div>
                            <div className="stats__sub-wrap stats__sub-wrap--female">
                                <div className="stats__sub-caption">Жен.:</div>
                                <div className="stats__sub-value">{ usersStats.female }</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stats__item">
                    <div className="stats__caption">Количество абонементов</div>
                    <div className="stats__content">
                        <i className="stats__ico stats__ico--subscriptions" />
                        <div className="stats__value">{ usersStats.subscriptions_count }</div>
                        <div className="stats__sub">
                            <div className="stats__sub-wrap stats__sub-wrap--active">
                                <div className="stats__sub-caption">Активир.:</div>
                                <div className="stats__sub-value">{ usersStats.active_subscriptions }</div>
                            </div>
                            <div className="stats__sub-wrap stats__sub-wrap--inactive">
                                <div className="stats__sub-caption">Неактив.:</div>
                                <div className="stats__sub-value">{ usersStats.inactive_subscriptions }</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stats__item">
                    <div className="stats__caption">Сейчас в зале</div>
                    <div className="stats__content">
                        <i className="stats__ico stats__ico--activity" />
                        <div className="stats__value">{ usersStats.workouts_run }</div>
                    </div>
                </div>
                <div className="stats__item">
                    <div className="stats__caption">Сегодня занимались</div>
                    <div className="stats__content">
                        <i className="stats__ico stats__ico--done" />
                        <div className="stats__value">{ usersStats.workouts_done }</div>
                    </div>
                </div>
            </div>
            <div className="table__wrapper">
                <div className="table__header">
                    <div className="table__caption">Типы абонементов</div>
                </div>
                <div className="table table--stats">
                    <div className="table__row table__row--header stats__row">
                        <div className="table__cell table__cell--left">Тип абонемента</div>
                        <div className="table__cell">Активированные абонементы</div>
                        <div className="table__cell">Неактивированные абонементы</div>
                    </div>
                    {
                        usersStats.types.map(elem => {
                            return (
                                <div className="table__row table__row--hover stats__row" key={ elem.id }
                                     onClick={ () => {
                                         // Переходим на страницу с абонементами
                                         history.push('/fitness/subscriptions');
                                         dispatch(searchAction(elem.name));
                                     } }
                                >
                                    <div className="table__cell table__cell--left">{ elem.name }</div>
                                    <div className="table__cell">{ elem.active }</div>
                                    <div className="table__cell">{ elem.inactive }</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default UsersStats;